import NP from "./NP";

NP.FontImages = {
	text: 'ic_text',
	integration: 'ic_integration',
	web: 'ic_web',
	user: 'ic_user',
	user_outline: 'ic_user_outline',
	tab: 'ic_tab',
	supervisor_account: 'ic_supervisor_account',
	shape: 'ic_shape',
	settings: 'ic_settings',
	settings_applications: 'ic_settings_applications',
	security: 'ic_security',
	rounded_rectangle: 'ic_rounded_rectangle',
	report: 'ic_report',
	rectangle: 'ic_rectangle',
	receipt: 'ic_receipt',
	presentation: 'ic_presentation',
	mail: 'ic_mail',
	mail_outline: 'ic_mail_outline',
	line: 'ic_line',
	library: 'ic_library',
	language: 'ic_language',
	key: 'ic_key',
	image: 'ic_image',
	home: 'ic_home',
	group: 'ic_group',
	group_outline: 'ic_group_outline',
	folder: 'ic_folder',
	folder_shared: 'ic_folder_shared',
	folder_open: 'ic_folder_open',
	file: 'ic_file',
	elbow_connector: 'ic_elbow_connector',
	description: 'ic_description',
	data_source: 'ic_data_source',
	dashboard: 'ic_dashboard',
	company: 'ic_company',
	circle: 'ic_circle',
	arrow: 'ic_arrow',
	chart: 'ic_chart',
	chart_template: 'ic_chart_template',
	billing: 'ic_billing',
	assistant: 'ic_assistant',
	alert: 'ic_alert',
	alert_outline: 'ic_alert_outline',
	account_circle: 'ic_account_circle',
	account_box: 'ic_account_box',
	account_balance: 'ic_account_balance',
	title: 'ic_title',
	text_fields: 'ic_text_fields',
	shop: 'ic_shop',
	send: 'ic_send',
	reply: 'ic_reply',
	new_releases: 'ic_new_releases',
	layers: 'ic_layers',
	label: 'ic_label',
	label_outline: 'ic_label_outline',
	whatshot: 'ic_whatshot',
	split: 'ic_split',
	lock: 'ic_lock',
	lock_outline: 'ic_lock_outline',
	lock_open: 'ic_lock_open',
	import_contacts: 'ic_import_contacts',
	fiber_new: 'ic_fiber_new',
	attach_money: 'ic_attach_money',
	attach_file: 'ic_attach_file',
	stop_screen_share: 'ic_stop_screen_share',
	screen_share: 'ic_screen_share',
	present_to_all: 'ic_present_to_all',
	zoom_out: 'ic_zoom_out',
	zoom_out_map: 'ic_zoom_out_map',
	zoom_in: 'ic_zoom_in',
	word_cloud: 'ic_word_cloud',
	treemap: 'ic_treemap',
	tooltip: 'ic_tooltip',
	stepline: 'ic_stepline',
	stacked_column: 'ic_stacked_column',
	stacked_bar: 'ic_stacked_bar',
	stacked_area: 'ic_stacked_area',
	spline: 'ic_spline',
	single_value: 'ic_single_value',
	simple_table: 'ic_simple_table',
	simple_line: 'ic_simple_line',
	series_marker_secondary: 'ic_series_marker_secondary',
	series_marker_primary: 'ic_series_marker_primary',
	series_line_secondary: 'ic_series_line_secondary',
	series_line_primary: 'ic_series_line_primary',
	series_bar_secondary: 'ic_series_bar_secondary',
	series_bar_primary: 'ic_series_bar_primary',
	series_area_secondary: 'ic_series_area_secondary',
	series_area_primary: 'ic_series_area_primary',
	selection: 'ic_selection',
	quote: 'ic_quote',
	progress_bar: 'ic_progress_bar',
	pie: 'ic_pie',
	pan_tool: 'ic_pan_tool',
	measure: 'ic_measure',
	measure_names: 'ic_measure_names',
	marker_x_mark: 'ic_marker_x_mark',
	marker_triangle: 'ic_marker_triangle',
	marker_square: 'ic_marker_square',
	marker_pentagon: 'ic_marker_pentagon',
	marker_hexagon: 'ic_marker_hexagon',
	marker_diamond: 'ic_marker_diamond',
	marker_circle: 'ic_marker_circle',
	map: 'ic_map',
	map_circle: 'ic_map_circle',
	line_chart: 'ic_line_chart',
	histogram: 'ic_histogram',
	google_maps: 'ic_google_maps',
	geo: 'ic_geo',
	gauge: 'ic_gauge',
	funnel: 'ic_funnel',
	flag: 'ic_flag',
	donut: 'ic_donut',
	donut_with_total: 'ic_donut_with_total',
	dimension: 'ic_dimension',
	date_range: 'ic_date_range',
	cross_table: 'ic_cross_table',
	combo_chart: 'ic_combo_chart',
	column: 'ic_column',
	calculation: 'ic_calculation',
	bullet: 'ic_bullet',
	scatter_plot: 'ic_scatter_plot',
	bar: 'ic_bar',
	area_chart: 'ic_area_chart',
	add_location: 'ic_add_location',
	extension: 'ic_extension',
	bug_report: 'ic_bug_report',
	aspect_ratio: 'ic_aspect_ratio',
	watch: 'ic_watch',
	tv: 'ic_tv',
	tablet: 'ic_tablet',
	smartphone: 'ic_smartphone',
	pin: 'ic_pin',
	laptop: 'ic_laptop',
	error: 'ic_error',
	cursor: 'ic_cursor',
	airplay: 'ic_airplay',
	warning: 'ic_warning',
	mode_comment: 'ic_mode_comment',
	insert_comment: 'ic_insert_comment',
	error_outline: 'ic_error_outline',
	create_new_folder: 'ic_create_new_folder',
	attachment: 'ic_attachment',
	view_module: 'ic_view_module',
	view_list: 'ic_view_list',
	twitter: 'ic_twitter',
	tutorial: 'ic_tutorial',
	swap: 'ic_swap',
	swap_vertical_circle: 'ic_swap_vertical_circle',
	swap_vert: 'ic_swap_vert',
	swap_horiz: 'ic_swap_horiz',
	stars: 'ic_stars',
	star: 'ic_star',
	star_outline: 'ic_star_outline',
	star_half: 'ic_star_half',
	slack: 'ic_slack',
	select_all: 'ic_select_all',
	reorder: 'ic_reorder',
	radiobutton_unchecked: 'ic_radiobutton_unchecked',
	radiobutton_checked: 'ic_radiobutton_checked',
	microsoft: 'ic_microsoft',
	live_help: 'ic_live_help',
	linkedin: 'ic_linkedin',
	knowledge_base: 'ic_knowledge_base',
	indeterminate_checkbox: 'ic_indeterminate_checkbox',
	indeterminate_checkbox_s: 'ic_indeterminate_checkbox_s',
	history: 'ic_history',
	highlight_off: 'ic_highlight_off',
	help: 'ic_help',
	help_outline: 'ic_help_outline',
	google: 'ic_google',
	flip_to_front: 'ic_flip_to_front',
	flip_to_back: 'ic_flip_to_back',
	favorite: 'ic_favorite',
	favorite_outline: 'ic_favorite_outline',
	facebook: 'ic_facebook',
	event: 'ic_event',
	emoji: 'ic_emoji',
	drag_handle: 'ic_drag_handle',
	done_all: 'ic_done_all',
	clear_all: 'ic_clear_all',
	check_circle: 'ic_check_circle',
	cached: 'ic_cached',
	bookmark: 'ic_bookmark',
	bookmark_outline: 'ic_bookmark_outline',
	autorenew: 'ic_autorenew',
	border_color: 'ic_border_color',
	wrap_text: 'ic_wrap_text',
	vertical_align_top: 'ic_vertical_align_top',
	vertical_align_center: 'ic_vertical_align_center',
	vertical_align_bottom: 'ic_vertical_align_bottom',
	underline: 'ic_underline',
	tonality: 'ic_tonality',
	style: 'ic_style',
	strikethrough: 'ic_strikethrough',
	solid_color: 'ic_solid_color',
	line_weight: 'ic_line_weight',
	line_style: 'ic_line_style',
	rounded_corner: 'ic_rounded_corner',
	palette: 'ic_palette',
	opacity: 'ic_opacity',
	italic: 'ic_italic',
	gradient: 'ic_gradient',
	format_size: 'ic_format_size',
	format_paint: 'ic_format_paint',
	format_color_reset: 'ic_format_color_reset',
	format_clear: 'ic_format_clear',
	colorize: 'ic_colorize',
	color_text: 'ic_color_text',
	color_fill: 'ic_color_fill',
	brush: 'ic_brush',
	border_vertical: 'ic_border_vertical',
	border_top: 'ic_border_top',
	border_style: 'ic_border_style',
	border_right: 'ic_border_right',
	border_outer: 'ic_border_outer',
	border_left: 'ic_border_left',
	border_inner: 'ic_border_inner',
	border_horizontal: 'ic_border_horizontal',
	border_clear: 'ic_border_clear',
	border_bottom: 'ic_border_bottom',
	border_all: 'ic_border_all',
	bold: 'ic_bold',
	auto: 'ic_auto',
	align_right: 'ic_align_right',
	align_left: 'ic_align_left',
	align_justify: 'ic_align_justify',
	align_center: 'ic_align_center',
	visibility: 'ic_visibility',
	visibility_off: 'ic_visibility_off',
	person_add: 'ic_person_add',
	upload: 'ic_upload',
	undo: 'ic_undo',
	tune: 'ic_tune',
	sort: 'ic_sort',
	sort_alpha: 'ic_sort_alpha',
	slideshow: 'ic_slideshow',
	share: 'ic_share',
	search: 'ic_search',
	schedule: 'ic_schedule',
	save: 'ic_save',
	save_as: 'ic_save_as',
	save_as_pdf: 'ic_save_as_pdf',
	rename: 'ic_rename',
	remove: 'ic_remove',
	remove_circle: 'ic_remove_circle',
	remove_circle_outline: 'ic_remove_circle_outline',
	refresh: 'ic_refresh',
	redo: 'ic_redo',
	play_circle: 'ic_play_circle',
	play_circle_outline: 'ic_play_circle_outline',
	play_arrow: 'ic_play_arrow',
	paste: 'ic_paste',
	open_in_new: 'ic_open_in_new',
	move_to: 'ic_move_to',
	link: 'ic_link',
	info: 'ic_info',
	info_outline: 'ic_info_outline',
	group_add: 'ic_group_add',
	filter: 'ic_filter',
	edit: 'ic_edit',
	download: 'ic_download',
	delete: 'ic_delete',
	cut: 'ic_cut',
	copy: 'ic_copy',
	code: 'ic_code',
	build: 'ic_build',
	block: 'ic_block',
	add: 'ic_add',
	add_circle: 'ic_add_circle',
	add_circle_outline: 'ic_add_circle_outline',
	subdirectory_arrow_right: 'ic_subdirectory_arrow_right',
	subdirectory_arrow_left: 'ic_subdirectory_arrow_left',
	more_vert: 'ic_more_vert',
	more_horiz: 'ic_more_horiz',
	minimize: 'ic_minimize',
	menu: 'ic_menu',
	maximize: 'ic_maximize',
	last_page: 'ic_last_page',
	fullscreen: 'ic_fullscreen',
	fullscreen_exit: 'ic_fullscreen_exit',
	first_page: 'ic_first_page',
	explore: 'ic_explore',
	expand_more: 'ic_expand_more',
	expand_less: 'ic_expand_less',
	exit_to_app: 'ic_exit_to_app',
	close: 'ic_close',
	chevron_right: 'ic_chevron_right',
	chevron_left: 'ic_chevron_left',
	check: 'ic_check',
	cancel: 'ic_cancel',
	arrow_upward: 'ic_arrow_upward',
	arrow_sort_table_up: 'ic_arrow_sort_table_up',
	arrow_sort_table_down: 'ic_arrow_sort_table_down',
	arrow_forward: 'ic_arrow_forward',
	arrow_drop_up: 'ic_arrow_drop_up',
	arrow_drop_down: 'ic_arrow_drop_down',
	arrow_drop_down_circle: 'ic_arrow_drop_down_circle',
	arrow_downward: 'ic_arrow_downward',
	arrow_back: 'ic_arrow_back',
	arrow_right: 'ic_arrow_right',
	apps: 'ic_apps',
	norm_stacked_column: "ic_norm_stacked_column",
	norm_stacked_bar: 'ic_norm_stacked_bar',
	norm_stacked_area: 'ic_norm_stacked_area',

	check_box_s: "ic_check_box_s",
	check_box_outline_s: "ic_check_box_outline_s",
	check_box_outline: "ic_check_box_outline",
	check_box: "ic_check_box",
	format_line_spacing: 'ic_format_line_spacing',
	alternate_email: 'ic_alternate_email',
	pipedrive: 'ic_pipedrive',
	grand_total: 'ic_grand_total',
	row_total: 'ic_row_total',
	column_total: 'ic_column_total',
	spin_down: 'ic_spin_down',
	spin_up: 'ic_spin_up',
	toggle_off: 'ic_toggle_off',
	toggle_on: 'ic_toggle_on',
	database: 'ic_database',
	list: "ic_list",
	supervisor_account_tt: "ic_supervisor_account_tt",
	knowledge_base_tt: "ic_knowledge_base_tt",
	geo_tt: "ic_geo_tt",
	fight_tt: "ic_fight_tt",
	star_tt: "ic_star_tt",
	gender: "ic_gender",
	weight: "ic_weight",
};